
<template>
  <div>
    <div class="disFlex between curse-search">
      <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="">
            <el-select v-model="formInline.itype" placeholder="题型" clearable>
              <el-option key="1" label="单选" value="1"></el-option>
              <el-option key="2" label="多选" value="2"></el-option>
              <el-option key="3" label="判断" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" style="width: 130px;">
            <el-select v-model="formInline.state" placeholder="请选择状态" clearable>
              <el-option label="已生效" value="1"></el-option>
              <el-option label="禁用" value="2"></el-option>
              <el-option label="未生效" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-loading="loading" style="padding: 10px;background-color: #fff;">
      <el-table @select-all="selectAllUser" @select="selectShiti" ref="multipleTable" row-key="id"
        @selection-change="selectChangeUser" :data="tableData.rows" style="width: 100%;margin-bottom: 20px;" border>
        <el-table-column type="selection" width="55" :reserve-selection="true">
        </el-table-column>
        <el-table-column prop="cname" fixed width="350" label="题目">
        </el-table-column>
        <el-table-column prop="itype" label="题型" width="100" sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.itype==1">单选</span>
            <span v-if="scope.row.itype==2">多选</span>
            <span v-if="scope.row.itype==3">判断</span>
          </template>
        </el-table-column>
        <el-table-column prop="parentname" label="所属分类" sortable width="150">
        </el-table-column>
        <el-table-column prop="createName" width="120" label="创建人员">
        </el-table-column>
        <el-table-column prop="createTime" width="160" label="创建时间">
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px;text-align: right;" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page="formInline.page" :page-sizes="[10, 20, 30, 50]"
        :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total">
      </el-pagination>
    </div>

  </div>
</template>

<script>
  export default {
    props: ['selectShitiIds', 'currentUser','selectMrRows','isdelete','parentid'],
    data() {
      return {
        progressPercent: 0,
        progressVisible: false,
        formInline: {
          parentid: '',
          page: 1,
          rows: 10,
          itype: '',
          cid: ''
        },
        tableData: {
          rows: [],
          total: 0
        },
        selectIdArr: [],
        selectRows: [],
        loading: true
      }
    },
    methods: {
      getcurseList: function() {
        this.loading = true;
        this.$axios.get('/kt/ktQuestions/getlistPage.htm?' + this.$qs.stringify(this.formInline), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data.stat == '0') {
            this.$message.error(data.message);
          } else {
            this.tableData = data;
            if(this.selectMrRows.length>0){
              console.log('this.selectMrRows.length:',this.selectMrRows.length)
              this.$refs.multipleTable.clearSelection();
              this.selectMrRows.map((item)=>{
                this.$refs.multipleTable.toggleRowSelection(item,true)
              })
            }
          }
          this.loading = false;
        })
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
      selectChangeUser: function(selection, row) {
        this.$emit('changeSt',selection);
      },
      selectAllUser: function(selection, row) {
      },
      selectShiti: function(selection, row) {
      }
    },
    created: function() {
      this.$set(this.formInline, 'cid', this.currentUser.cid);
      this.$set(this.formInline, 'parentid', this.parentid);
    },
    components: {},
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getcurseList(1)
        },
        deep: true //true 深度监听
      },
      selectMrRows: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          if(val&&this.selectShitiIds.length>0&&this.isdelete){
            this.$refs.multipleTable.clearSelection();
            val.map((item,i)=>{
              if(this.selectShitiIds.indexOf(item.id)>=0){
                this.$refs.multipleTable.toggleRowSelection(item,true)
              }
            })
          }
        },
        deep: true //true 深度监听
      },
    }
  }
</script>

<style>
  .curse-search {
    padding: 20px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin: 20px auto;
  }

  .curse-search .el-form-item {
    margin-bottom: 0;
  }

  .curseInfoBlock {
    width: 256px;
    height: 256px;
    opacity: 1;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
    margin: 0 20px 20px 0;
  }

  .curseevery-title {
    width: 236px;
    height: 40px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 20px;
    margin: 8px auto;
  }

  .curseevery-title span {
    width: 34px;
    height: 16px;
    opacity: 1;
    background: linear-gradient(126deg, #ff7254 11%, #ff1515 90%);
    border-radius: 6px 6px 6px 0px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.05);
    color: #fff;
    font-size: 12px;
    display: inline-block;
    line-height: 16px;
    text-align: center;
    margin-right: 2px;
  }

  .curseevery-bot {
    width: 256px;
    height: 43px;
    opacity: 1;
    background: #fbfbfc;
    border-top: 1px solid #efefef;
    align-items: center;
    color: #9a9a9a;
    font-size: 13px;
    cursor: pointer;

  }

  .curseevery-bot img {
    margin-right: 4px;
  }

  .curseevery-top {
    position: relative;
  }

  .curseevery-top.ygq::after {
    content: "";
    content: '';
    display: block;
    width: 46px;
    height: 46px;
    background: url(../../assets/images/ygq.png) no-repeat;
    background-size: 46px 46px;
    position: absolute;
    right: 0;
    top: -1px;
  }

  .delVurse {
    position: absolute;
    width: 100%;
    height: 100%;
    display: none;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    align-items: center;
    justify-content: center;
    transition: all 0.3s linear;
  }

  .delVurse span {
    cursor: pointer;
    font-size: 14px;
    color: #ff1515;
  }

  .curseevery-top:hover .delVurse {
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/ComTiku.vue